/** Minimal persisted facts needed to share the runtime's progress scope. */
interface CountedProgressStep {
  countsTowardsProgress?: boolean;
  reasonCode?: string;
}

/** Exclude passive presentation and conditional branches that do not apply. */
export function getCountedProgressSteps<T extends CountedProgressStep>(steps: readonly T[]): T[] {
  return steps.filter(step => step.countsTowardsProgress !== false && step.reasonCode !== 'condition_not_met');
}
